import { render } from "./Terms.vue?vue&type=template&id=62cbe149&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=62cbe149&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LYRASHOES/mi-stock-lyrashoes-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cbe149"]])

export default __exports__